import { render } from "./ThxInfosView.vue?vue&type=template&id=63317637&scoped=true"
import script from "./ThxInfosView.vue?vue&type=script&lang=js"
export * from "./ThxInfosView.vue?vue&type=script&lang=js"

import "./ThxInfosView.vue?vue&type=style&index=0&id=63317637&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63317637"]])

export default __exports__